import { MenuItem } from '@chakra-ui/react';

const DropdownMenuOption = ({ children, onClick }) => {
  return (
    <MenuItem
      sx={{ maxWidth: '144px', justifyContent: 'flex-end', fontSize: '16px' }}
      _focus={{ backgroundColor: 'orange.100', fontWeight: '700' }}
      onClick={onClick}
    >
      {children}
    </MenuItem>
  );
};
export default DropdownMenuOption;